import { UserRoleCatalog, UserRoleIds, UserRoles, UserRoleToIdMap } from '../types/user-roles';
import { v4 as uuid } from 'uuid';

function createUserRoleMapping<T extends Partial<UserRoleCatalog>>(
  mapping: T & {
    [K in keyof Partial<UserRoleToIdMap>]: {
      roleId: UserRoleToIdMap[K];
    };
  },
): T {
  return mapping;
}

export const DEFAULT_USER_ROLE_CONTENT_PREFIX = 'userRoles';

export const invitationRoles: Pick<UserRoleCatalog, UserRoles.MANAGER | UserRoles.USER> =
  createUserRoleMapping({
    [UserRoles.MANAGER]: {
      id: uuid(),
      role: UserRoles.MANAGER,
      roleId: UserRoleIds.MANAGER,
      labelAccessor: 'manager.label',
      descriptionAccessor: 'manager.description',
    },
    [UserRoles.USER]: {
      id: uuid(),
      role: UserRoles.USER,
      roleId: UserRoleIds.USER,
      labelAccessor: 'user.label',
      descriptionAccessor: 'user.description',
    },
  });

export const genericRoles: Omit<UserRoleCatalog, keyof typeof invitationRoles> =
  createUserRoleMapping({
    [UserRoles.OWNER]: {
      id: uuid(),
      role: UserRoles.OWNER,
      roleId: UserRoleIds.OWNER,
      labelAccessor: 'fullAccess.label',
      descriptionAccessor: 'fullAccess.description',
    },
    [UserRoles.ADMIN]: {
      id: uuid(),
      role: UserRoles.ADMIN,
      roleId: UserRoleIds.ADMIN,
      labelAccessor: 'admin.label',
      descriptionAccessor: 'admin.description',
    },
    [UserRoles.PENDING]: {
      id: uuid(),
      role: UserRoles.PENDING,
      roleId: UserRoleIds.PENDING,
      labelAccessor: 'pending.label',
      descriptionAccessor: 'pending.description',
    },
    [UserRoles.SALESPERSON]: {
      id: uuid(),
      role: UserRoles.SALESPERSON,
      roleId: UserRoleIds.SALESPERSON,
      labelAccessor: 'salesPerson.label',
      descriptionAccessor: 'salesPerson.description',
    },
    [UserRoles.OPERATIONS]: {
      id: uuid(),
      role: UserRoles.OPERATIONS,
      roleId: UserRoleIds.OPERATIONS,
      labelAccessor: 'operations.label',
      descriptionAccessor: 'operations.description',
    },
    [UserRoles.DRIVER]: {
      id: uuid(),
      role: UserRoles.DRIVER,
      roleId: UserRoleIds.DRIVER,
      labelAccessor: 'driver.label',
      descriptionAccessor: 'driver.description',
    },
  });

export const userRoles: UserRoleCatalog = {
  ...invitationRoles,
  ...genericRoles,
};
